import produce, {Draft} from 'immer';
import {handleActions} from 'redux-actions';
import {ActionType} from 'redux-promise-middleware';
import {Reducer} from 'redux';

import actions from '../actions';
import initialState from '../store/initialState';
import constants from '@constants';

const reducer: Reducer<UsersStore, any> = handleActions(
  {
    [`${actions.users.getOneUser}_${ActionType.Fulfilled}`](
      state: UsersStore,
      action: any
    ) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.detail = action.payload.detail;
      });

      // 権限が特権管理者者でない場合、エラーにする
      if (action.payload.isOnlyAdmin) {
        if (newState.detail.authLevel === constants.AUTHORITIES.GENERAL) {
          throw new Error('not admin user');
        }
      }

      return newState;
    },
    [`${actions.users.updateUser}_${ActionType.Fulfilled}`](
      state: UsersStore,
      action: any
    ) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.detail = action.payload.detail;
      });

      return newState;
    },
    [`${actions.users.getUserDetail}`](state: UsersStore, action: any) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.detail = action.payload.detail;
      });

      return newState;
    },
    [`${actions.users.getUserDetail}_${ActionType.Fulfilled}`](
      state: UsersStore,
      action: any
    ) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.detail = action.payload.detail;
      });

      return newState;
    },
    [`${actions.users.clearUserDetail}`](state: UsersStore, action: any) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.detail = action.payload;
      });

      return newState;
    },

    // 検索キーワード
    [`${actions.users.updateSearchWordsUsers}_${ActionType.Fulfilled}`](
      state: UsersStore,
      action: any
    ) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.search = action.payload.keywords;
        draftState.pagination.data = action.payload.pagination.data;
        draftState.pagination.totalCount = action.payload.pagination.totalCount;
        draftState.pagination.totalPages = action.payload.pagination.totalPages;
        draftState.pagination.current = action.payload.pagination.current;
        draftState.pagination.sort = action.payload.pagination.sort;
      });
      return newState;
    },

    [`${actions.users.clearSearchWords}`](state: UsersStore, action: any) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.search = action.payload;
      });
      return newState;
    },
    [`${actions.users.clearTableSort}`](state: UsersStore, action: any) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.pagination.sort = action.payload.sort;
      });

      return newState;
    },

    // ページング用
    [`${actions.users.updateActiveUsers}`](state: UsersStore, action: any) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.pagination.data.active = action.payload.active;
        draftState.pagination.current = action.payload.nextCurrent;
      });
      return newState;
    },
    [`${actions.users.updateCurrentUsers}_${ActionType.Fulfilled}`](
      state: UsersStore,
      action: any
    ) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.pagination.data = action.payload.data;
        draftState.pagination.totalCount = action.payload.totalCount;
        draftState.pagination.totalPages = action.payload.totalPages;
        draftState.pagination.current = action.payload.current;
        draftState.pagination.sort = action.payload.sort;
      });
      return newState;
    },
  },
  initialState.users
);

export default reducer;
